import React from 'react'
import './Nav.css'
import icon from '../img/icon-wh.png'
import Avatar from './Avatar.js';

function Nav(props){

const openEnlace = async () => {
  try {
    // 1) pedir token al servidor (MISMO host)
    const res = await fetch("http://isight.cl/mel/enlace/mint.php", {
      method: "GET",
      credentials: "include",
      cache: "no-store",
    });

    const data = await res.json();

    if (!res.ok || !data.ok) {
      window.location.href = "http://isight.cl";
      return;
    }

    // 2) redirigir al index.php con user firmado + view=enlace (IMPORTANTE)
    const url =
      `http://isight.cl/mel/enlace/index.php?view=enlace` +
      `&u=${encodeURIComponent(data.u)}` +
      `&ts=${encodeURIComponent(data.ts)}` +
      `&sig=${encodeURIComponent(data.sig)}`;

    window.location.href = url;
  } catch (e) {
    window.location.href = "http://isight.cl";
  }
};



  return(
    <nav className="nav">
      <img src={icon} alt="Logo" className="logo"/>
      <h3 className='main-title'>ISIGHT</h3>
      <h3 className='second-title'>MONITOREO REMOTO</h3>

      <div className="nav-right">
        <Avatar mail={props.user} logout={props.cookDestr}/>

        <button
          type="button"
          className="btn-enlace"
          onClick={openEnlace}
        >
          Enlazar equipo
        </button>

        <span className="app-version">{props.appVersion}</span>
      </div>
    </nav>
  )
}

export default Nav
